import NoData from '@monorepo/common/component/NoData';
import QueryWithLoader from '@monorepo/common/component/QueryWithLoader';
import ResponsiveHeaderRow from '@monorepo/common/component/responsive/ResponsiveHeaderRow';
import React from 'react';
import { Redirect } from 'react-router-dom';
import { OrderDocument, OrderQuery, OrderQueryVariables } from '../../graphql-operations';
import OrderDetailView from './OrderDetailView';

interface OrderDetailProps {
  orderNumber?: string;
  listUrl: string;
}
export default function OrderDetail({ orderNumber, listUrl }: OrderDetailProps) {
  return (
    <>
      {/*Top header for small screens to go back to list*/}
      <ResponsiveHeaderRow to={listUrl}></ResponsiveHeaderRow>

      {!!orderNumber && (
        <QueryWithLoader<OrderQuery, OrderQueryVariables> query={OrderDocument} variables={{ orderNumber }}>
          {({ data }) => {
            const order = data.order;

            if (!order) {
              return <Redirect to="/page-not-found" />;
            }

            return <OrderDetailView order={order} />;
          }}
        </QueryWithLoader>
      )}

      {!orderNumber && <NoData text="Vyberte objednávku" />}
    </>
  );
}
